import {
	UPDATE_SHIFTPLAN_SENIORITY,
	SET_SHIFTPLAN_SENIORITY,
	RESET_SHIFTPLAN_SENIORITY,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	ADD_BATCH_LIST_ITEM_ROW,
} from './shiftplanSeniority.actions';

// utils
import _uniqueId from 'lodash/uniqueId';

const defaultState = {
	data: {
		defaultShiftplanSeniority: {},
		batchList: [
			{
				identifier: _uniqueId('row-'),
				name: '',
				description: '',
				badge: '',
				minimumHours: null,
				maximumHours: null,
			},
		],
	},
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_SHIFTPLAN_SENIORITY: {
			return {
				data: {
					defaultShiftplanSeniority: payload,
				},
			};
		}

		case UPDATE_SHIFTPLAN_SENIORITY: {
			return {
				data: {
					defaultShiftplanSeniority: {
						...state.data.defaultShiftplanSeniority,
						...payload,
					},
				},
			};
		}

		case RESET_SHIFTPLAN_SENIORITY: {
			return {
				...defaultState,
			};
		}

		case EDIT_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.map((entry) => {
						if (entry.identifier === payload.identifier) return payload;
						return entry;
					}),
				},
			};
		}

		case REMOVE_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.filter(
						(entry) => entry.identifier !== payload
					),
				},
			};
		}

		case ADD_BATCH_LIST_ITEM_ROW: {
			return {
				...state,
				data: {
					...state.data,
					batchList: [
						...state.data.batchList,
						{
							...defaultState.data.batchList[0],
							identifier: _uniqueId('row-'),
						},
					],
				},
			};
		}

		default:
			return state;
	}
}

export default reducer;
